export const baseURL =  process.env.NODE_ENV === 'production' ? 
    '' :
    // `http://dev.tillage-cloud.com:8083/pangu/`
    // 'http://tesing.china-tillage.com:19998'
    'http://www.china-tillage.com:8000/'
    // 'http://192.168.5.114:8090/pangu/'
export const version = "2.0.1"